import Chip from "@mui/material/Chip";
import { useTranslation } from "i18n-fe";

// #587 — the three-state life of an admin-visible ScoreSheet: OPEN (marks +
// comments both editable) -> CONFIRMED (marks server-frozen by #697, comments
// still open -- the non-obvious middle state that IS the point of
// confirm-score: the number is already out to the announcer/FVD while the
// judge keeps writing) -> SIGNED (fully frozen, judge signature present).
// Mirrors common-fe's RideStatusBadge: semantic MUI Chip colors only, so
// light/dark theming is automatic. NEVER brand `primary` here -- it's dark
// grey and disappears on a dark background.
// #868 — labelKey is a static i18n key (i18n-fe requires literal keys, no
// interpolation); the label text itself lives in scoreadmin.json.
export const SHEET_STATE_DISPLAY = {
  OPEN: { color: "default", labelKey: "sheetState.open" },
  CONFIRMED: { color: "warning", labelKey: "sheetState.confirmed" },
  SIGNED: { color: "success", labelKey: "sheetState.signed" },
};

export function deriveSheetState(sheet) {
  if (sheet?.completedAt) return "SIGNED";
  if (sheet?.marksConfirmedAt) return "CONFIRMED";
  return "OPEN";
}

export default function SheetStateChip({ state, size = "small", ...props }) {
  const { t } = useTranslation("scoreadmin");
  const display = SHEET_STATE_DISPLAY[state] ?? SHEET_STATE_DISPLAY.OPEN;
  return (
    <Chip
      size={size}
      color={display.color}
      label={t(display.labelKey)}
      variant={state === "OPEN" ? "outlined" : "filled"}
      {...props}
    />
  );
}
